import { getIndexesFromDeviceTree, } from 'console/sortableDeviceTree/utils/group-utils';
import * as lodash from 'lodash';
function getAllGroup(device_tree) {
    const indexed_device_tree = getIndexesFromDeviceTree(device_tree);
    if (indexed_device_tree == null)
        return [];
    return indexed_device_tree
        .map((indexed_device_tree_item) => {
        if (indexed_device_tree_item.item != null &&
            'Children' in indexed_device_tree_item.item)
            return indexed_device_tree_item;
        return null;
    })
        .filter((item) => item != null);
}
export function getGroupsNameWithPath(device_tree) {
    if (device_tree == null)
        return [];
    return getAllGroup(device_tree)
        .map((group) => {
        if (group != null &&
            group.item != null &&
            'Name' in group.item &&
            'id' in group.item)
            return { name: group.item.Name, path: group.path, id: group.item.id };
        if (group != null && group.item != null && 'Name' in group.item)
            return { name: group.item.Name, path: group.path };
        return null;
    })
        .filter((item) => item != null);
}
export function getKeyForList(groupWithPath, groups) {
    if (groupWithPath.name === 'Нет группы')
        return '-1';
    //Иначе надо сравнить по пути!
    //!!! из findGroupForDevice пришёл путь до устройства
    const exist_path = groupWithPath.path.slice(0, -1);
    const find_key = groups
        .map((group, index) => {
        if (lodash.isEqual(exist_path, group.path))
            return index;
        return null;
    })
        .find((item) => item != null);
    return find_key != null ? find_key.toString() : '-1';
}
